module.exports = __webpack_public_path__ + "static/media/image-card-2.f8cbbf4a.png";